<template>
  <div>
    <h2>Répartition de la dotation</h2>
    <br />
    <apexchart
      type="bar"
      width="750"
      height="350"
      ref="barLots"
      :options="options"
      :series="series"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
Vue.component("apexchart", VueApexCharts);

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  props: {
    chartDatas: {
      type: Object,
      required: false,
      default: function() {
        return {};
      },
    },
  },
  watch: {
    chartDatas: {
      deep: true,
      handler(newValue) {
        var data = newValue.stats_lots;
        this.basechart(data);
      },
    },
  },
  data: function() {
    return {
      numb: [],
      options: {},
      series: [],
    };
  },
  methods: {
    basechart(data) {
      var lots = [];
      var tt_lots = [];

      data.forEach(function(element) {
        if (element._id.lot) {
          lots.push(element._id.libelle);
          tt_lots.push(element.count);
        }
      });

      this.series = [
        {
          data: tt_lots,
        },
      ];
      this.options = {
        xaxis: {
          categories: lots,
        },
      };

      try {
        this.$refs.barLots.updateSeries(this.series, true);
        this.$refs.barLots.updateOptions(this.options, false, true);
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
